export default {
    'name': 'looong-arrow',
    'width': '79',
    'height': '79',
    'viewBox': '0 0 79 79',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M38.3263 0.260966C38.5041 0.0988562 38.7405 1.22344e-07 39 1.19249e-07C39.2595 1.16154e-07 39.4959 0.0988378 39.6736 0.260921L48.671 8.40238C49.0805 8.77294 49.112 9.40532 48.7415 9.81483C48.3709 10.2244 47.7385 10.2559 47.329 9.88537L40 3.2535L40 78C40 78.5523 39.5523 79 39 79C38.4477 79 38 78.5523 38 78L38 3.2535L30.671 9.88537C30.2614 10.2559 29.6291 10.2244 29.2585 9.81483C28.8879 9.40532 28.9195 8.77294 29.329 8.40238L38.3263 0.260966Z\' fill=\'white\'/>'
}
